import DetailFullPage from './DetailFullPage';

export default DetailFullPage;
